import { Spin, Table, TableColumnsType } from "antd";
import { AirdropAllocationType, AirdropType } from "../../../type";
import { useCallback, useMemo, useState } from "react";
import { shortenAddress } from "../../../helpers";

const AirdropReward = ({
  allocation,
  airdrop,
  handleClaimAirdrop,
}: {
  allocation: AirdropAllocationType[];
  airdrop: AirdropType | undefined;
  handleClaimAirdrop: (allocation: AirdropAllocationType) => Promise<void>;
}) => {
  const [loadingId, setLoadingId] = useState<number | undefined>();

  const claimStart = airdrop?.start_claim_time
    ? new Date(airdrop?.start_claim_time).getTime()
    : undefined;
  const claimEnd = airdrop?.end_claim_time
    ? new Date(airdrop?.end_claim_time).getTime()
    : undefined;
  const currentTime = Date.now();

  const handleClaimClick = useCallback(
    async (allocation: AirdropAllocationType) => {
      setLoadingId(allocation.id);
      await handleClaimAirdrop(allocation);
      setLoadingId(undefined);
    },
    [handleClaimAirdrop]
  );

  const columns: TableColumnsType<AirdropAllocationType> = useMemo(
    () => [
      {
        title: () => (
          <div className="text-text-secondary uppercase font-Montserrat font-semibold">
            Amount
          </div>
        ),
        dataIndex: "amount",
        render: (_text, record, _index) => (
          <div className="text-text-secondary uppercase font-Montserrat font-semibold">
            {record.amount} {airdrop?.token.symbol}
          </div>
        ),
      },
      {
        title: () => (
          <div className="text-text-secondary uppercase font-Montserrat font-semibold">
            Transaction
          </div>
        ),
        dataIndex: "tnx",
        render: (_text, record, _index) => (
          <a
            href={record.txn_link}
            target="_blank"
            className="text-text-secondary uppercase font-Montserrat font-semibold"
            rel="noreferrer"
          >
            {shortenAddress(record.txn, 10, 6)}
          </a>
        ),
      },
      {
        title: () => (
          <div className="text-text-secondary uppercase font-Montserrat font-semibold">
            Status
          </div>
        ),
        dataIndex: "claim",
        render: (_text, record, _index) => {
          if (record.claimed)
            return (
              <div className="w-fit text-green-900 bg-green-200 px-3 py-1 rounded-md">
                Claimed
              </div>
            );
          else if (
            !claimStart ||
            !claimEnd ||
            claimStart > currentTime ||
            claimEnd < currentTime
          )
            return (
              <div className="w-20 h-9 flex justify-center items-center bg-gray-600 rounded-md text-white font-semibold text-base">
                Claim
              </div>
            );
          return (
            <button
              onClick={() => handleClaimClick(record)}
              className={`min-w-20 h-9 flex justify-center items-center bg-customBlue-500 rounded-md text-white font-semibold text-base
                   ${airdrop?.start_claim_time}`}
            >
              {loadingId === record.id ? (
                <>
                  <style>{`
                      .my-spin-wrapper .ant-spin-dot-item {
                        background-color: white;
                      }
                    `}</style>
                  <Spin
                    size="small"
                    style={{ color: "white" }}
                    className="my-spin-wrapper"
                  />
                </>
              ) : (
                "Claim"
              )}
            </button>
          );
        },
      },
    ],
    [
      airdrop?.start_claim_time,
      airdrop?.token.symbol,
      claimEnd,
      claimStart,
      currentTime,
      handleClaimClick,
      loadingId,
    ]
  );

  return (
    <div className="w-full">
      {airdrop?.status === "READY" && allocation && allocation.length > 0 ? (
        <div className="bg-backgroundWhite p-4 flex justify-center items-center text-text-secondary overflow-y-hidden overflow-x-scroll no-scrollbar">
          <Table<AirdropAllocationType>
            columns={columns}
            dataSource={allocation || []}
            style={{ width: "100%" }}
          />
        </div>
      ) : (
        <div className=" bg-backgroundWhite pb-10 pt-5 px-4 flex flex-col justify-center items-center">
          {airdrop?.status === "PENDING" ? (
            <>
              <img
                src="/images/winner-comming-soon.png"
                alt=""
                className="h-40 w-40 object-contain"
              />
              <div className="font-medium text-xl uppercase font-Azonix">
                <span className="text-customBlue-500">Winners list </span>
                coming soon!
              </div>
            </>
          ) : (
            <>
              <img
                src="/images/airdrop-result.png"
                alt=""
                className="h-40 w-40 object-contain"
              />
              <div className="font-medium text-xl uppercase font-Azonix">
                You didn’t win this airdrop!
              </div>
            </>
          )}
        </div>
      )}
      <div className="w-full h-auto flex justify-end">
        <img
          src="/images/line-open.png"
          alt=""
          className="max-w-full w-[500px] h-auto"
        />
      </div>
    </div>
  );
};

export default AirdropReward;
